import React from 'react';
import styled from 'styled-components';

// Below this bar width the note no longer fits on one line between the side
// columns, so the measurements label joins the note instead of sitting apart.
const COMPACT_BAR = '@container planner-bottom-bar (max-width: 1560px)';

const BottomBar = () => {
    return (
        <Bar>
            <Inner>
                <Disclaimer>
                    <strong>Note:</strong> The 3D preview is for demonstration
                    purposes only. Appliances are shown for visual reference and
                    are not included in your order. Final product composition
                    may change at manufacture.
                    <InlineMeta> All measurements in mm.</InlineMeta>
                </Disclaimer>
                <Meta>
                    <span>All measurements in mm</span>
                </Meta>
            </Inner>
        </Bar>
    );
};

const Bar = styled.footer`
    position: relative;
    container: planner-bottom-bar / inline-size;
    flex-shrink: 0;
    z-index: 20;
    background: #fff;
    border-top: 1px solid #eceff3;
    color: #6b7280;
    font-size: 12px;
    font-weight: 500;
`;

const Inner = styled.div`
    display: grid;
    /* The note is centred while it fits on one line; the measurements label
       keeps its own column until COMPACT_BAR moves it into the note. */
    grid-template-columns: 1fr minmax(0, max-content) 1fr;
    align-items: center;
    gap: 16px;
    min-height: 32px;
    padding: 6px 16px;
`;

const Disclaimer = styled.p`
    grid-column: 2;
    margin: 0;
    line-height: 1.3;
    text-align: center;

    ${COMPACT_BAR} {
        grid-column: 1 / -1;
    }
`;

const InlineMeta = styled.span`
    display: none;

    ${COMPACT_BAR} {
        display: inline;
    }
`;

const Meta = styled.div`
    grid-column: 3;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;
    white-space: nowrap;

    ${COMPACT_BAR} {
        display: none;
    }
`;

export default BottomBar;
